<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Gestión de Clientes
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar cliente..."
          single-line
          hide-details
          outlined
          dense
          clearable
          class="mr-2"
        ></v-text-field>
        <v-btn color="primary" dark @click="$router.push({ name: 'AdminClientCreate' })">
          <v-icon left>mdi-plus</v-icon> Añadir Cliente
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="customers"
          :server-items-length="totalItems"
          :options.sync="options"
          :loading="loading"
          loading-text="Cargando clientes..."
          no-data-text="No se encontraron clientes"
          class="elevation-1"
        >
          <template #[`item.MAXDEBT`]="{ item }">
            ${{ Number(item.MAXDEBT || 0).toFixed(2) }}
          </template>
          <template #[`item.VISIBLE`]="{ item }">
            <v-chip x-small :color="item.VISIBLE ? 'green' : 'grey'" dark>
              {{ item.VISIBLE ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="$router.push({ name: 'AdminClientEdit', params: { id: item.ID } })">
              mdi-pencil
            </v-icon>
            <v-icon small color="red" @click="deleteCustomer(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDeleteDialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Confirmar Eliminación</v-card-title>
        <v-card-text>
          ¿Estás seguro de que quieres eliminar al cliente "{{ itemToDelete ? itemToDelete.NAME : '' }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeDeleteDialog">Cancelar</v-btn>
          <v-btn color="red darken-1" text :loading="loading" @click="confirmDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as customerService from '@/services/customerService';

export default {
  name: 'ClientAdminView',
  data() {
    return {
      loading: false,
      search: '',
      debouncedSearch: null,
      showDeleteDialog: false,
      itemToDelete: null,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      totalItems: 0,
      customers: [],
      headers: [
        { text: 'Código', value: 'SEARCHKEY', sortable: true },
        { text: 'Nombre', value: 'NAME', sortable: true },
        { text: 'RFC / Tax ID', value: 'TAXID', sortable: true },
        { text: 'Teléfono', value: 'PHONE', sortable: false },
        { text: 'Email', value: 'EMAIL', sortable: false },
        { text: 'Ciudad', value: 'CITY', sortable: true },
        { text: 'Deuda Máxima', value: 'MAXDEBT', sortable: true },
        { text: 'Estatus', value: 'VISIBLE', sortable: true },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
      ],
    };
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.fetchCustomers();
      },
    },
    search() {
      clearTimeout(this.debouncedSearch);
      this.debouncedSearch = setTimeout(() => {
        this.options.page = 1;
        this.fetchCustomers();
      }, 350);
    },
  },
  mounted() {
    this.fetchCustomers();
  },
  methods: {
    async fetchCustomers() {
      this.loading = true;
      try {
        const data = await customerService.fetchCustomers({
          ...this.options,
          q: this.search || undefined,
        });
        this.customers = data.customers || [];
        this.totalItems = data.totalCount || 0;
      } catch (error) {
        this.customers = [];
        this.totalItems = 0;
        this.$emit('show-alert', { message: 'Error al cargar clientes.', type: 'error' });
      } finally {
        this.loading = false;
      }
    },
    deleteCustomer(item) {
      this.itemToDelete = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.$nextTick(() => {
        this.itemToDelete = null;
      });
    },
    async confirmDelete() {
      if (!this.itemToDelete) return;
      this.loading = true;
      try {
        await customerService.deleteCustomer(this.itemToDelete.ID);
        this.$emit('show-alert', { message: 'Cliente eliminado con éxito.', type: 'success' });
        this.closeDeleteDialog();
        this.fetchCustomers();
      } catch (error) {
        this.$emit('show-alert', {
          message: `Error al eliminar cliente: ${error.response?.data?.mensaje || error.message}`,
          type: 'error',
        });
        this.closeDeleteDialog();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
